import { RootState } from 'app/store';

export const selectAuthToken = (state: RootState): string | null =>
  state.auth.token;
export const selectIsLoggedIn = (state: RootState): boolean =>
  state.auth.isLoggedIn;
export const selectIsLoading = (state: RootState): boolean =>
  state.auth.isLoading;
